import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SectionRenderer from './SectionRenderer';

const SpotlightPortfolioLayout = ({ siteConfig }) => {
  const order = Array.isArray(siteConfig?.sectionOrder) && siteConfig.sectionOrder.length
    ? siteConfig.sectionOrder
    : ['hero', 'projects', 'about', 'skills', 'experience', 'contact'];
  const visibility = siteConfig?.sectionVisibility || {};

  return (
    <div className="theme-layout-spotlight">
      <Header />
      <main className="theme-main-shell">
        {order.map((sectionKey) => {
          if (visibility[sectionKey] === false) {
            return null;
          }

          return <SectionRenderer key={sectionKey} sectionKey={sectionKey} />;
        })}
      </main>
      {visibility.footer !== false && <Footer />}
    </div>
  );
};

export default SpotlightPortfolioLayout;
